<mb-card class="hotel-loading" *ngFor="let hotel of [1, 2, 3, 4, 5]">
  <div class="hotel-loading__content mb-grid-container-full mb-grid-row">
    <div class="hotel-loading__image mb-grid-col-4-dt mb-grid-col-4">
      <div class="hotel-loading__image-loader"></div>
    </div>
    <div class="hotel-loading__details mb-grid-col-5-dt mb-grid-col-4">
      <div class="hotel-loading__details-title"></div>
      <div class="hotel-loading__details-subtitle"></div>
      <div class="hotel-loading__details-footer">
        <div class="hotel-loading__details-rating"></div>
        <div class="hotel-loading__details-rating-label"></div>
      </div>
    </div>
    <div class="hotel-loading__price-box mb-grid-col-3-dt mb-grid-col-4">
      <div class="hotel-loading__price-box-price"></div>
      <div class="hotel-loading__price-box-button"></div>
    </div>
  </div>
</mb-card>
